/**
 * Constants and enums for Hold Campaign Leaderboard
 */

// Epoch Status Enum
export enum EpochStatus {
  ACTIVE = "active",
  COMPLETED = "completed",
  PENDING = "pending",
  PAUSED = "paused",
}

// User Participation Status Constants
export const USER_PARTICIPATION_STATUS = {
  NOT_PARTICIPATING: "not_participating",
  PARTICIPATING: "participating",
  HOLDING: "holding",
  OPTED_OUT: "opted_out",
} as const;

// Leaderboard Constants
export const LEADERBOARD_CONSTANTS = {
  // Ranking
  TOP_TIER_RANK_THRESHOLD: 3,
  MEDAL_RANKS: [1, 2, 3] as const,

  // Auto-scroll
  AUTO_SCROLL_DELAY: 50,
  AUTO_SCROLL_MARGIN_BUFFER: 10,

  // Skeleton loading
  SKELETON_ROWS_COUNT: 5,

  // Table dimensions
  RANK_COLUMN_WIDTH: "w-16",
  ADDRESS_COLUMN_WIDTH: "w-32",
  AMOUNT_COLUMN_WIDTH: "w-32",
  AVG_AMOUNT_COLUMN_WIDTH: "w-36",
  PRIZE_COLUMN_WIDTH: "w-28",

  // Tooltip constants
  TOOLTIP_WIDTH: "w-80",

  // Medal colors (CSS custom properties)
  MEDAL_COLORS: {
    GOLD: "var(--color-medal-gold)",
    SILVER: "var(--color-medal-silver)",
    BRONZE: "var(--color-medal-bronze)",
  },

  // Medal gradients (CSS custom properties)
  MEDAL_GRADIENTS: {
    GOLD: "var(--gradient-medal-gold)",
    SILVER: "var(--gradient-medal-silver)",
    BRONZE: "var(--gradient-medal-bronze)",
  },
} as const;

// Type guard functions
export const isTopTierRank = (rank: number): boolean => {
  return rank <= LEADERBOARD_CONSTANTS.TOP_TIER_RANK_THRESHOLD;
};

export const isMedalRank = (rank: number): rank is 1 | 2 | 3 => {
  return LEADERBOARD_CONSTANTS.MEDAL_RANKS.includes(rank as 1 | 2 | 3);
};

// Utility type for medal ranks
export type MedalRank = (typeof LEADERBOARD_CONSTANTS.MEDAL_RANKS)[number];
